import styled from 'styled-components'

export const DocumentParagraph = styled.p`
  margin: 0;
  margin-bottom: 15px;
`

export const DocumentH1 = styled.h1`
  margin: 0;
  margin-bottom: 15px;
  font-size: 26px;
  color: ${props => props.theme.textDocumentSectionHeader};
`

export const DocumentH2 = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  font-size: 22px;
  color: ${props => props.theme.textDocumentSectionHeader};
`

export const DocumentH3 = styled.h3`
  margin: 0;
  margin-bottom: 15px;
  font-size: 18px;
  color: ${props => props.theme.textDocumentSectionHeader};
`

export const DocumentHR = styled.hr`
  margin-top: 0;
`

export const DocumentInlineCode = styled.code`
  background: ${props => props.theme.hoverBg};
  border-radius: 3px;
  padding: 2px 4px;
  color: inherit;
`

export const DocumentPre = styled.pre`
  display: block;
  background: ${props => props.theme.bgSecondLightest};
  border: 1px solid ${props => props.theme.borderColor};
  border-radius: 3px;
  width: 100%;
  padding: 15px;
  line-height: 1.45em;
  font-size: 13.5px;
  font-family: monospace;
`

export const DocumentQuote = styled.blockquote`
  margin: 15px 0;
  border-left: 3px solid ${props => props.theme.borderColor};
  padding: 0;
`

export const DocumentQuoteContent = styled.div`
  padding: 16px 20px 0;
  white-space: pre-wrap;
  word-break: break-word;
`

export const DocumentTable = styled.table`
  width: 100%;
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`

export const DocumentThead = styled.thead`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const DocumentTbody = styled.tbody`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const DocumentTr = styled.tr`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: row;
`

export const DocumentTh = styled.th`
  border-bottom: 2px solid ${props => props.theme.borderColor};
  padding: 0.5rem;
  background: ${props => props.theme.bgLightest};
  color: ${props => props.theme.textGreyTinted};
  position: relative;
  font-size: 15px;
  border-right: 5px solid ${props => props.theme.bgLightest};
  display: block;
  width: 100%;

  &:last-child {
    border-right: 0;
  }

  &:hover {
    background: ${props => (props.readOnly ? props.theme.bgLightest : props.theme.bgSecondLightest)};
  }

  p {
    margin-bottom: 0;
  }

  .element {
    width: 100% !important;
  }
`

export const DocumentTd = styled.td`
  position: relative;
  border-bottom: 1px solid ${props => props.theme.borderColor};
  border-right: 5px solid ${props => props.theme.bgLightest};
  padding: 0.5rem;
  background: ${props => props.theme.bgLightest};
  font-size: 15px;
  display: block;
  width: 100%;

  &:hover {
    background: ${props => (props.readOnly ? props.theme.bgLightest : props.theme.bgSecondLightest)};
  }

  p {
    margin-bottom: 0;
  }

  &:last-child {
    border-right: 0;
  }

  .element {
    width: 100% !important;
  }
`
